<template>
  <div class="left">
    <!-- 日期/币种 -->
    <div class="box head">
      <div class="date">{{ dateText }} {{ currency }}</div>
      <button class="keno-refresh refresh" :disabled="loadingBalance" @click="$emit('refresh-balance')"></button>
    </div>

    <!-- Balances / Outstanding -->
    <div class="box kv">
      <div class="row">
        <div class="k">{{$t('left.balances')}}:</div>
        <div class="v">{{ fmt2(balance) }}</div>
      </div>
      <div class="row">
        <div class="k">{{$t('left.outstanding')}}:</div>
        <div class="v">{{ fmt2(outstanding) }}</div>
      </div>
    </div>

    <!-- Last Result -->
    <div class="box title-row">
      <div class="title">{{$t('left.lastResult')}}</div>
      <button class="keno-refresh refresh" :disabled="loadingLast" @click="$emit('refresh-last')"></button>
    </div>
    <div class="box list">
      <div class="line" v-for="x in last5" :key="x.issueNo">
        <div class="l">{{ x.issueNo }} {{ x.timeText }}</div>
        <div class="r">{{ x.sumText }}</div>
      </div>
      <div v-if="!last5.length" class="empty">-</div>
    </div>

    <!-- Current Ticket -->
    <div class="box title-row">
      <div class="title">{{$t('left.currentTicket')}}</div>
      <button class="keno-refresh refresh" :disabled="loadingTicket" @click="$emit('refresh-ticket')"></button>
    </div>

    <div class="ticket-wrap">
      <!-- ✅ 期号标题条：带底色，样式对齐你图 -->
      <div class="ticket-issuebar">
        <div class="issue-left">
          <span class="lotto">Lotto</span>
          <span class="no">{{ currentIssueShort }}</span>
        </div>

        <div class="issue-icons">
          <span class="mini printer-green" @click="printGroup(currentIssueShort, currentBets, 'current')"></span>
          <span class="mini printer-b" @click="printGroup(currentIssueShort, currentBets, 'current')"></span>
        </div>
      </div>


      <div v-if="!currentBets.length" class="ticket-empty">-</div>

      <div v-for="(b, idx) in currentBets" :key="'c'+idx" class="ticket-line">
        <span class="expr">{{ betExprText(b) }}</span>
        <span class="eq"> = </span>
        <span class="result">???</span>
      </div>
    </div>

    <!-- Previous Ticket -->
    <div class="box title-row">
      <div class="title">{{$t('left.previousTicket')}}</div>
      <button class="keno-refresh refresh" :disabled="loadingPrev" @click="$emit('refresh-prev')"></button>
    </div>

    <div v-if="!prevGroups.length" class="ticket-wrap">
      <div class="ticket-empty">-</div>
    </div>

    <div v-for="g in prevGroups" :key="g.issueNo" class="ticket-wrap">
      <!-- ✅ 每一期一个标题条（带底色） -->
      <div class="ticket-issuebar">
        <div class="issue-left">
          <span class="lotto">Lotto</span>
          <span class="no">{{ g.issueShort }}</span>
        </div>

        <div class="issue-icons">
          <span class="mini printer-green" @click="printGroup(g.issueShort, g.bets, 'prev')"></span>
          <span class="mini printer-b" @click="printGroup(g.issueShort, g.bets, 'prev')"></span>
        </div>
      </div>


      <div v-if="!g.bets || !g.bets.length" class="ticket-empty">-</div>

      <div v-for="(b, idx) in g.bets" :key="g.issueNo + '-' + idx" class="ticket-line">
        <span class="expr">{{ betExprText(b) }}</span>
        <span class="eq"> = </span>
        <span class="result" :class="resultClass(b)">{{ prevResultText(b) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dateText: { type: String, default: "" },
    currency: { type: String, default: "KHR" },
    balance: { type: Number, default: 0 },
    outstanding: { type: Number, default: 0 },
    last5: { type: Array, default: () => [] },
    kenoConfig: { type: Object, default: () => ({}) },
    currentIssueShort: { type: String, default: "-" },
    currentBets: { type: Array, default: () => [] },

    prevGroups: { type: Array, default: () => [] },

    loadingBalance: { type: Boolean, default: false },
    loadingLast: { type: Boolean, default: false },
    loadingTicket: { type: Boolean, default: false },
    loadingPrev: { type: Boolean, default: false }
  },
  methods: {
    fmt0(n) {
      const v = Number(n || 0);
      return v.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    },
    fmt2(n) {
      const v = Number(n || 0);
      return v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    fmtOdds(n) {
      const v = Number(n);
      if (Number.isNaN(v)) return "-";
      // 参考图 odds 不强制补 2 位（4.6 / 1.95 都保持原样即可）
      return String(v);
    },

    betLabel(optionCode) {
      const code = String(optionCode || "").toUpperCase();

      if (code === "OVER") {
        return this.$t('lotto.over') || "O";
      }

      if (code === "UNDER") {
        return this.$t('lotto.under') || "U";
      }

      if (code.startsWith("R") && code.length === 2) {
        return code.substring(1); // R3 -> 3
      }

      return code || "-";
    },

    // "2 2,000x4.6" / "ធំ 1,000x1.95"
    betExprText(b) {
      const label = this.betLabel(b.optionCode);
      const amount = this.fmt0(b.amount);
      const odds = this.fmtOdds(b.odds);
      return `${label} ${amount}x${odds}`;
    },

    // Previous：显示 winAmount；没有则 0
    prevResultText(b) {
      if (b.winAmount === null || b.winAmount === undefined) return "0";
      return this.fmt0(b.winAmount);
    },

    // Previous：赢钱蓝，输钱红（0/空 都红）
    resultClass(b) {
      const w = (b.winAmount === null || b.winAmount === undefined) ? 0 : Number(b.winAmount || 0);
      return w > 0 ? "win" : "lose";
    },
    // 把 optionCode 转成： "210-810(under)" / "811-1410(over)" / "856-923(4)"
    betTypeTextByConfig(optionCode) {
      const code = String(optionCode || "").toUpperCase();
      const cfg = this.kenoConfig || {};

      const under = cfg.under || {};
      const over = cfg.over || {};
      const ranges = Array.isArray(cfg.ranges) ? cfg.ranges : [];

      if (code === "UNDER") {
        const min = under.min != null ? under.min : "-";
        const max = under.max != null ? under.max : "-";
        return String(min) + "-" + String(max) + "(under)";
      }
      if (code === "OVER") {
        const min = over.min != null ? over.min : "-";
        const max = over.max != null ? over.max : "-";
        return String(min) + "-" + String(max) + "(over)";
      }

      if (code.startsWith("R")) {
        const r = ranges.find(x => String(x.code || "").toUpperCase() === code);
        const min = r && r.min != null ? r.min : "-";
        const max = r && r.max != null ? r.max : "-";
        const n = code.replace("R", "");
        return String(min) + "-" + String(max) + "(" + String(n) + ")";
      }

      return code || "-";
    },

// win/lose 字段：未开奖 "??"；已开奖显示正负数（你示例：-1000 / 3900）
    winLoseText(b) {
      if (!b) return "??";

      // ✅ 优先用 status 判断：0=未结算(未开奖/未派彩)，1=已结算
      const status = Number(b.status);

      // 未结算：显示 ??
      if (Number.isFinite(status) && status !== 1) return "??";

      // ✅ 兜底：如果没有 status，就用 settledAt 判断
      if (!Number.isFinite(status)) {
        const settledAt = String(b.settledAt || "").trim();
        if (!settledAt) return "??";
      }

      // ✅ 已结算：赢钱显示 winAmount；输钱显示 -stake
      const winAmount = Number(b.winAmount || 0);
      if (winAmount > 0) return String(winAmount);

      const stake = Number(b.amount || 0);
      return String(-stake);
    },

    printGroup(issueShort, bets) {
      const list = Array.isArray(bets) ? bets : [];
      if (!list.length) {
        alert(this.$t("common.noTicket") || "No ticket");
        return;
      }

      const esc = (s) =>
          String(s ?? "")
              .replace(/&/g, "&amp;")
              .replace(/</g, "&lt;")
              .replace(/>/g, "&gt;")
              .replace(/"/g, "&quot;")
              .replace(/'/g, "&#039;");

      const now = new Date();
      const printTime =
          now.getFullYear() + "-" +
          String(now.getMonth() + 1).padStart(2, "0") + "-" +
          String(now.getDate()).padStart(2, "0") + " " +
          String(now.getHours()).padStart(2, "0") + ":" +
          String(now.getMinutes()).padStart(2, "0") + ":" +
          String(now.getSeconds()).padStart(2, "0");

      // ✅ 用户名：按你要求从 store 取
      const username = this.$store.getters["auth/user"]?.username || "USERNAME";

      // ✅ 打印字段文案：根据当前语言（i18n）
      const L = {
        issue: this.$t("print.issue") || "លេខសំបុត្រ",
        ticketId: this.$t("print.ticketId") || "លេខសម្គាល់",
        time: this.$t("print.time") || "ថ្ងៃទី",
        betType: this.$t("print.betType") || "ប្រភេទភ្នាល់",
        coef: this.$t("print.coef") || "មេគុណ",
        winlose: this.$t("print.winlose") || "ឈ្នះ ចាញ់",
      };

      const cardsHtml = list.map((b) => {
        const ticketId = b && b.id != null ? String(b.id) : "-";
        const createdAt = b && b.createdAt
            ? String(b.createdAt).replace("T", " ").slice(0, 19)
            : printTime;

        const betType = this.betTypeTextByConfig(b ? b.optionCode : "");
        const coef = this.fmt0((b && b.amount) || 0) + " x " + String((b && b.odds) != null ? b.odds : "-");
        const wl = this.winLoseText(b);

        return [
          '<div class="ticket">',
          '  <div class="ticket-title">' + esc(username) + "</div>",
          '  <div class="ticket-line"><span class="k">' + esc(L.issue) + ':</span><span class="v">' + esc(issueShort || "-") + "</span></div>",
          '  <div class="ticket-line"><span class="k">' + esc(L.ticketId) + ':</span><span class="v">' + esc(ticketId) + "</span></div>",
          '  <div class="ticket-line"><span class="k">' + esc(L.time) + ':</span><span class="v">' + esc(createdAt) + "</span></div>",
          '  <div class="ticket-line"><span class="k">' + esc(L.betType) + ':</span><span class="v">' + esc(betType) + "</span></div>",
          '  <div class="ticket-line"><span class="k">' + esc(L.coef) + ':</span><span class="v">' + esc(coef) + "</span></div>",
          '  <div class="ticket-line"><span class="k">' + esc(L.winlose) + ':</span><span class="v">' + esc(wl) + "</span></div>",
          "</div>",
        ].join("\n");
      }).join("\n");

      const html = [
        "<!doctype html>",
        "<html>",
        "<head>",
        '  <meta charset="utf-8" />',
        "  <title>Print</title>",
        "  <style>",
        "    @page { size: A4; margin: 12mm; }",
        "    html, body { margin:0; padding:0; font-family: Arial, sans-serif; color:#000; }",
        "    .sheet { width:100%; }",
        "    .print-time{ font-size:12px; margin:0 0 6px 0; color:#000; }",
        "    .center-wrap{ display:flex; justify-content:center; }",
        "    .ticket{ width:320px; border:1px solid #000; padding:10px 12px; margin:16px 0; page-break-inside:avoid; }",
        "    .ticket-title{ text-align:center; font-weight:700; text-decoration:underline; margin-bottom:10px; }",
        "    .ticket-line{ font-size:13px; line-height:1.6; white-space:nowrap; display:flex; gap:6px; }",
        "    .k{ font-weight:700; }",
        "    .v{ font-weight:600; }",
        "  </style>",
        "</head>",
        "<body>",
        '  <div class="sheet">',
        '    <div class="print-time">' + esc(printTime) + "</div>",
        '    <div class="center-wrap"><div>',
        cardsHtml,
        "    </div></div>",
        "  </div>",
        "</body>",
        "</html>",
      ].join("\n");

      // ✅ iframe 打印（不弹窗）
      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";
      document.body.appendChild(iframe);

      const doc = iframe.contentDocument || iframe.contentWindow.document;
      doc.open();
      doc.write(html);
      doc.close();

      setTimeout(() => {
        try {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        } finally {
          setTimeout(() => {
            if (iframe && iframe.parentNode) iframe.parentNode.removeChild(iframe);
          }, 800);
        }
      }, 200);
    }
  }
};
</script>

<style scoped>
.left{
  width: 200px;
  min-height: 1020px;
  height: 100%;
  overflow: auto;
  border-right:1px solid #b9cdec;
  padding:0;
  background: #FFFFFF;
}


.box{
  border-bottom:1px solid #b9cdec;
  padding:0;
  background:#eaf3ff;
}

.head{
  display:flex; justify-content:space-between; align-items:center;
  background:#d3e4f6;
  height: 32px;
  padding: 0 15px;
  box-sizing: border-box;
}
.date{ font-weight:bold; color:#27448c; font-size:16px; }

.refresh{
  width:20px; height:20px;
  border:1px solid #b9cdec;
  border-radius:3px;
  background:#ffffff;
  cursor:pointer;
  display:flex;
  align-items:center;
  justify-content:center;
  padding: 0;
}
.refresh:disabled{ opacity:.6; cursor:not-allowed; }

/* 刷新按钮图片样式 - 使用 ~@ 格式 */
/* 刷新按钮图片样式 - 使用 ~@ 格式 */
.keno-refresh {
  display: block;
  width: 14px;
  height: 14px;
  background: url(~@/assets/img/refresh.png) center no-repeat;
  cursor: pointer;
  border: none;
  background-size: contain;
}

/* 加载旋转效果 */
.keno-refresh:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 给刷新按钮添加旋转动画 */
.keno-refresh.spin {
  animation: spin .8s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0); }
  to { transform: rotate(360deg); }
}

.kv{ background:#ffffff; padding: 2px 15px; }
.row{ display:flex; justify-content:space-between; margin:2px 0; color:#27448c; font-weight:bold;font-size: 14px; }
.v{ font-weight:bold; }

.title-row{
  display:flex; justify-content:space-between; align-items:center;
  background:#d3e4f6;
  height: 32px;
  padding: 0 15px;
  box-sizing: border-box;
}
.title{ font-weight:bold; color:#27448c; font-size:16px; }

/* Last Result：斑马纹 */
.list{
  background:#ffffff;
  padding: 0;
  margin: 0;
}

.list .line{
  padding: 0 15px;
  margin: 0;
  height: 24px;
  line-height: 24px;
  border-bottom: none;
  color: #666666;
  font-weight: 600;
}

/* 奇偶行不同色 */
.list .line:nth-child(odd){
  background: #ffffff;
}
.list .line:nth-child(even){
  background: #f2f6f9;
}

/* hover 可选（像原站那样更明显） */
.list .line:hover{
  background: #dcecff;
}

.list .l{
  color: #666666;        /* 左边：期号 + 时间 */
  font-weight: 600;
}

.list .r{
  color: #666666;
  font-weight: bold;
}
.line{
  display:flex; justify-content:space-between; align-items:center;
  padding:4px 0;
  font-size:11px;
  color:#1f4f7a;
}
.line:last-child{ border-bottom:0; }
.l{ white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:190px; }
.r{ font-weight:bold; }
.empty{ color:#8aa6c7; font-weight:bold; }

/* ✅ Ticket 区 */
.ticket-wrap{
  background:#ffffff;
  border-bottom:1px solid #b9cdec;
  padding:0;
}

/* ✅ Lotto 期号标题条：浅蓝底色 */
.ticket-issuebar{
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding:0 15px;
  background:#d3e4f6;
  height: 32px;
  box-sizing: border-box;
  border-bottom:1px solid #b9cdec;
}

.issue-left{
  display:flex;
  align-items:baseline;
  gap:6px;
  color:#27448c;
  font-weight:bold;
}
.lotto{ font-size:12px; }
.no{ font-size:12px; }

.issue-icons{
  display:flex;
  align-items:center;
  gap:6px;
}

/* 打印机图标样式 - 使用 ~@ 格式 */
.mini{
  width:18px;
  height:18px;
  display:inline-flex;
  align-items:center;
  justify-content:center;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
}
.printer-green {
  background-image: url(~@/assets/img/printer_green.svg);
}
.printer-b {
  background-image: url(~@/assets/img/printer_b.svg);
}

/* 行：一行公式 */
.ticket-empty{
  padding:8px 15px;
  color:#8aa6c7;
  font-weight:bold;
  font-size:11px;
}

.ticket-line{
  padding:6px 15px;
  font-size:11px;
  color:#666666;
  font-weight:bold;
  display:flex;
  align-items:baseline;
  gap:4px;
}
.ticket-line:last-child{ border-bottom:0; }

.expr{ }
.eq{ opacity:.9; }
.result{ font-weight:bold; color: #0037ff; } /* 未开奖 ??? 颜色 */

/* ✅ 赢钱蓝色，输钱红色 */
.result.win{ color:#0b63c7; }
.result.lose{ color:#FF0000; }
</style>